import { useState } from "react";
import Frame from "../Frames/Basic";
import { Alert, Stack, Typography} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import API from "../../services/API";
import Password from "../Inputs/Password";
import Tester from "../../services/Tester";
import { Navigate, useParams } from "react-router-dom";
import { txt } from "../../services/translation";

export default function ResetPassword(){

    const {key} = useParams()

    const [data, setData] = useState({password: '', confirm: '', key})
    const [errors, setErrors] = useState({})
    const [status, setStatus] = useState('ready')
    const statusIs = s => s === status


    const handleSubmit = e => {
        e.preventDefault()

        if( !validate() ) return false;

        setStatus('loading')

        API.post('/reset-password', data)
            .then(r => setStatus('success'))
            .catch(e => {
                setStatus('error')
                setErrors({server: e.response?.data?.error})
            })
    }


    const validate = () => {
        let e = {};
    
        if(!Tester.testPassword(data.password)) {
            e.password = txt('passwordRequirementMessage');
        }
    
        if(data.confirm !== data.password) {
            e.confirm = txt('passwordMismatchMessage');
        }
    
        setErrors(e);
    
        return Object.keys(e).length === 0;
    }


    if( statusIs('success') ) return <Navigate to='/login?reset=1'/>

    const sx = {
        maxWidth: 600,
        margin: 'auto'
    }

    return (
        <Frame center>
            <form onSubmit={handleSubmit}>
                <Stack spacing={3} sx={sx}>
                    <Typography variant='h2'>{txt('resetYourPassword')}</Typography>
    
                    {errors.server &&
                        <Alert severity='error'>{errors.server}</Alert>
                    }
    
                    <Password
                        label={txt('newPassword')}
                        value={data.password}
                        onChange={e => setData({...data, password: e.target.value})}
                        error={errors.password || false}
                        required
                        helperText={txt('passwordRequirementMessage')}
                    />
    
                    <Password
                        label={txt('confirmPassword')}
                        value={data.confirm}
                        onChange={e => setData({...data, confirm: e.target.value})}
                        error={errors.confirm || false}
                        required
                    />
    
                    <Stack direction='row' justifyContent='flex-end'>
                        <LoadingButton
                            type='submit'
                            variant='contained'
                            loading={statusIs('loading')}
                        >
                            {txt('validate')}
                        </LoadingButton>
                    </Stack>
                </Stack>
            </form>
        </Frame>
    );
    
}